// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IParticipantAddressInfoDto
 */
export interface IParticipantAddressInfoDto {
    /**
     * 
     * @type {string}
     * @memberof IParticipantAddressInfoDto
     */
    line1: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAddressInfoDto
     */
    line2?: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAddressInfoDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAddressInfoDto
     */
    state: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAddressInfoDto
     */
    zipcode: string;
    /**
     * 
     * @type {boolean}
     * @memberof IParticipantAddressInfoDto
     */
    undeliverable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAddressInfoDto
     */
    country_code: string;
    /**
     * 
     * @type {string}
     * @memberof IParticipantAddressInfoDto
     */
    address_type: IParticipantAddressInfoDtoAddressTypeEnum;
    /**
     * 
     * @type {Date}
     * @memberof IParticipantAddressInfoDto
     */
    undeliverable_at?: Date;
}

/**
* @export
* @enum {string}
*/
export enum IParticipantAddressInfoDtoAddressTypeEnum {
    PO_BOX = 'PO_BOX',
    RESIDENTIAL = 'RESIDENTIAL',
    BUSINESS = 'BUSINESS',
    UNKNOWN = 'UNKNOWN'
}


/**
 * Check if a given object implements the IParticipantAddressInfoDto interface.
 */
export function instanceOfIParticipantAddressInfoDto(value: object): value is IParticipantAddressInfoDto {
    if (!('line1' in value) || value['line1'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    if (!('zipcode' in value) || value['zipcode'] === undefined) return false;
    if (!('country_code' in value) || value['country_code'] === undefined) return false;
    if (!('address_type' in value) || value['address_type'] === undefined) return false;
    return true;
}

export function IParticipantAddressInfoDtoFromJSON(json: any): IParticipantAddressInfoDto {
    return IParticipantAddressInfoDtoFromJSONTyped(json, false);
}

export function IParticipantAddressInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IParticipantAddressInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'line1': json['line1'],
        'line2': json['line2'] == null ? undefined : json['line2'],
        'city': json['city'],
        'state': json['state'],
        'zipcode': json['zipcode'],
        'undeliverable': json['undeliverable'] == null ? undefined : json['undeliverable'],
        'country_code': json['country_code'],
        'address_type': json['address_type'],
        'undeliverable_at': json['undeliverable_at'] == null ? undefined : (new Date(json['undeliverable_at'])),
    };
}

export function IParticipantAddressInfoDtoToJSON(json: any): IParticipantAddressInfoDto {
    return IParticipantAddressInfoDtoToJSONTyped(json, false);
}

export function IParticipantAddressInfoDtoToJSONTyped(value?: IParticipantAddressInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'line1': value['line1'],
        'line2': value['line2'],
        'city': value['city'],
        'state': value['state'],
        'zipcode': value['zipcode'],
        'undeliverable': value['undeliverable'],
        'country_code': value['country_code'],
        'address_type': value['address_type'],
        'undeliverable_at': value['undeliverable_at'] == null ? undefined : ((value['undeliverable_at']).toISOString()),
    };
}

